<template>
  <div>
    <inactivity-time-modal
      :value="true"
      :time-init="timeInitChronometer"
      @finishSession="signOut"
      @continueSession="handleContinueSession"
    />
  </div>
</template>

<script>
  import InactivityTimeModal from '@/components/modals/InactivityTimeModal.vue';
  import userInactivityTime from '@/mixins/userInactivityTime';
  import { mapActions } from 'vuex';

  export default {
    components: {
      InactivityTimeModal,
    },
    mixins: [userInactivityTime],

    methods: {
      ...mapActions({
        signOutAction: 'auth/signOut',
        removeStep: 'modalStepsAfterLogin/removeStep',
      }),

      async handleContinueSession() {
        this.resetInactivityTimer();
        await this.removeStep('inactivity');
      },

      signOut() {
        this.signOutAction().then(() => {
          this.$router.replace({
            name: 'SignIn',
          });
        });
      },
    },
  };
</script>
